module.exports = __webpack_public_path__ + "static/event2020-ff297b4b2f7d01af6c1855b225330127.jpg";